// extracted by mini-css-extract-plugin
module.exports = {"collapsedArrowIcon":"Question_collapsedArrowIcon__mR81P","expandedArrowIcon":"Question_expandedArrowIcon__1wVoH"};